<template>
<div class="k__sub-category" id="k__sub-category">
  <div class="sub-category-wrapper" @scroll="handleScroll">
    <div
      v-for="(itemList, idx) in previewList"
      :key="idx"
      class="sub-category-list nowrap-list"
      :style="{ width: `calc(${previewList[0].length} * ((100vw - 15px) / 5)`}"
    >
      <div
        v-for="ctgItem in itemList"
        :key="ctgItem.id"
        :class="currentCid === ctgItem.id ? 'sub-item act-sub-item' : 'sub-item'"
        @click="handleCtgClick(ctgItem)"
      >
        <div class="inner-item">
          <div class="icon">
            <img v-lazy="$cvWebpFn(ctgItem.iconUrl)" />
            <span class="select-icon">
              <van-icon name="success" color="#fff" />
            </span>
          </div>
          <p class="title-text">{{ ctgItem.name }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="sidebar-box" v-show="previewList[0]?.length > 5">
    <div class="small-sidebar">
      <div class="inner-bar" :style="{ width: innerBarStyle.width, left: innerBarStyle.left }" />
    </div>
  </div>
</div>
</template>

<script setup lang="ts">
import { jumpCategoryBindUrl, type CategoryNavigationType } from '~/plugins/utils'

const props = withDefaults(
  defineProps<{
    categoryList: any[],
    currentCid?: number,
    rowTotal?: number
    /** 埋点 type：首页热门品类 hotCategory / 全品类 allCategory */
    categoryTrafficType?: CategoryNavigationType
  }>(),
  {
    rowTotal: 1,
    categoryList: () => ([]),
    categoryTrafficType: 'hotCategory'
  }
)
const emits = defineEmits<{
  (event: 'update:cid', id: number, name: string): void
}>()

interface IInnerBarStyle { width: string, left: string }

const { $throttle } = useNuxtApp()
const innerBarStyle = reactive<IInnerBarStyle>({
  width: '',
  left: '0%'
})

const handleScroll = $throttle((e: Event) => {
  const target = e.target as HTMLElement
  const { scrollLeft, scrollWidth } = target

  innerBarStyle.left = `${scrollLeft / scrollWidth * 100}%`
}, 15)

const previewList = computed(() => {
  const { categoryList, rowTotal } = props

  if(rowTotal <= 1 || categoryList.length <= 5) {
    return [categoryList]
  }
  
  const _list = []
  let rowCount = Math.ceil(categoryList.length / rowTotal)

  if(rowCount < 5) {
    rowCount = 5
  }
  for(let i = 0; i < rowTotal; i++) {
    _list.push(categoryList.slice(i * rowCount, i * rowCount + rowCount))
  }
  
  return _list
})

const initScrollBar = async() => {
  await new Promise(r => setTimeout(r, 50))

  innerBarStyle.width = `${(5 / previewList.value[0]?.length) * 100}%`
}

watch(() => previewList.value, initScrollBar)
onMounted(initScrollBar)

const handleCtgClick = async (item: ICategory) => {
  if(item.bindUrl) {
    jumpCategoryBindUrl(item.bindUrl, props.categoryTrafficType, item.name)
  } else {
    emits('update:cid', item.id, item.name)
  }
}
</script>

<style lang="scss" scoped>
.k__sub-category{
  padding: 10px;
  background-color: #fff;
}
.sub-category-wrapper{
  overflow: auto;
}
.sub-category-wrapper::-webkit-scrollbar{
  display: none;
}
.sub-category-list{
  display: flex;
  overflow: hidden;
  .sub-item{
    width: calc(20vw - 5px);;
    min-width: calc(20vw - 5px);
    padding: 5px;
    box-sizing: border-box;
    overflow: hidden;
    
    .inner-item{
      .icon{
        width: 100%;
        height: 0;
        padding-bottom: 100%;
        position: relative;
        border: 1px solid transparent;
        border-radius: 6px;
        overflow: hidden;
        img{
          position: absolute;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        .select-icon{
          display: none;
          position: absolute;
          z-index: 9;
          bottom: -18px;
          right: -18px;
          height: 50px;
          width: 50px;
          padding: 5px 0 0 5px;
          background-color: var(--default_color);
          border-radius:  50%;
        }
      }
      .title-text{
        font-size: 24px;
        color: #333;
        margin-top: 8px;
        text-align: center;
        height: 60px;
        @include ellipsisMultiline(2);
      }
    }
  }
  .act-sub-item .title-text{
    color: var(--default_color) !important;
  }
  .act-sub-item .icon{
    border-color: var(--default_color) !important;
    box-shadow: 0 0 6px var(--default_color);
    .select-icon{
      display: block !important;
    }
  }
}
.sidebar-box{
  text-align: center;
  margin-top: -10px;
  .small-sidebar{
    display: inline-block;
    position: relative;
    width: 100px;
    height: 6px;
    background-color: #f5f5f5;
    border-radius: 6px;
    overflow: hidden;
    .inner-bar{
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      border-radius: 6px;
      background-color: var(--default_color);
      width: 50px;
    }
  }
}
</style>